import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import MaleIcon from '../../../../icons/male.svg?react';
import FemaleIcon from '../../../../icons/female.svg?react'
import { useController, useForm, useFormContext } from 'react-hook-form';
import './GenderButtons.scss';

const CheckForError = (value, error) => {
  if (value === "F" || value === "M" || value === 'Female' || value === 'Male') {
    return false;
  } else if (error && error.message) {
    return true;
  }
  return false;
}

export default function GenderButtons(props) {
  const { name } = props
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm; // Fallback if used outside FormProvider
  const {
    field,
    fieldState: { error }
  } = useController({ name, control });

  useEffect(() => {
    if (props.selectedGender) {
      field.onChange(props.selectedGender);
    }
  }, [props.selectedGender]);

  return (
    <Row className="gender">
      <Col xs={6} className="pe-1">
        <div className="mb-3">
          <Button
            variant="outlined"
            className={(props.selectedGender === 'F' || props.selectedGender === 'Female') ? "primary-border-color buttonSelected" : props.selectedGender === 'M' || props.selectedGender === 'Male' ? "buttonNotSelected" : error !== undefined ? "styledButtonError" : "buttonNotSelected"}
            startIcon={<SvgIcon className="svgIcon" color='primary' component={FemaleIcon} />}
            id="female"
            onClick={props.onClickFemale}
            fullWidth
            color='inherit'
            aria-pressed={props.selectedGender === 'F'}
          >
            Female
          </Button>
          <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error" id="gender-helper-text" aria-describedby="gender-helper-text" >{CheckForError(props.selectedGender, error) ? error?.message : ""}</span>
        </div>
      </Col>

      <Col xs={6} className="ps-1">
        <div className="mb-3">
          <Button
            variant="outlined"
            className={(props.selectedGender === 'M' || props.selectedGender === 'Male') ? "primary-border-color buttonSelected" : props.selectedGender === 'F' || props.selectedGender === 'Female' ? "buttonNotSelected" : error !== undefined ? "styledButtonError" : "buttonNotSelected"}
            startIcon={<SvgIcon className="svgIcon" color='primary' component={MaleIcon} />}
            id="male"
            onClick={props.onClickMale}
            fullWidth
            color='inherit'
            aria-pressed={props.selectedGender === 'M'}
          >
            Male
          </Button>
        </div>
      </Col>
    </Row>
  );
}

GenderButtons.propTypes = {
  selectedGender: PropTypes.string,
  onClickMale: PropTypes.func.isRequired,
  onClickFemale: PropTypes.func.isRequired,
};
